define.alias("shared/utils/is-popup-window", "calendar/utils/is-popup-window");